import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Income, IUserData } from '../../../common/entities';
import {
  addIncome,
  deleteIncome,
  getIncome,
  listIncomes,
  setIncome,
  updateIncome
} from '../actions/incomes.actions';
import { getUserData } from '../actions/userData.actions';

interface IIncomesState {
  incomes: Income[];
  isLoading: boolean;
  error?: string;
  lastAction: string;
  currentIncome?: Income;
  hasLoaded?: boolean;
}

const initialState: IIncomesState = {
  incomes: [],
  isLoading: false,
  error: '',
  lastAction: '',
  currentIncome: undefined,
  hasLoaded: false
};

export const incomesSlice = createSlice({
  name: 'incomes',
  initialState: { ...initialState },
  reducers: {
    resetCurrentIncome: (state: IIncomesState) =>
      (state.currentIncome = undefined),
    resetIncomes(state, action: PayloadAction) {
      state.incomes = [];
      state.isLoading = false;
      state.currentIncome = undefined;
      state.error = '';
      state.hasLoaded = false;
      state.lastAction = '';
    }
  },
  extraReducers: {
    [getUserData.fulfilled.type]: (state, action: PayloadAction<IUserData>) => {
      state.isLoading = false;
      state.error = undefined;
      state.incomes = action.payload.incomes ?? [];
      state.hasLoaded = true;
    },
    [listIncomes.fulfilled.type]: (state, action: PayloadAction<Income[]>) => {
      state.isLoading = false;
      state.error = '';
      state.incomes = action.payload ?? [];
      state.lastAction = action.type;
      state.hasLoaded = true;
    },
    [listIncomes.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = state.lastAction = action.type;
    },
    [listIncomes.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    },
    [getIncome.fulfilled.type]: (state, action: PayloadAction<Income>) => {
      state.isLoading = false;
      state.error = '';
      state.currentIncome = action.payload;
      state.lastAction = action.type;
    },
    [getIncome.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = state.lastAction = action.type;
    },
    [getIncome.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    },
    [addIncome.fulfilled.type]: (state, action: PayloadAction<Income>) => {
      state.isLoading = false;
      state.error = '';
      state.lastAction = action.type;
    },
    [addIncome.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = action.type;
    },
    [addIncome.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    },
    [updateIncome.fulfilled.type]: (state, action: PayloadAction<Income>) => {
      state.isLoading = false;
      state.error = '';
      state.lastAction = action.type;
    },
    [updateIncome.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = action.type;
    },
    [updateIncome.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    },
    [deleteIncome.fulfilled.type]: (state, action: PayloadAction<Income>) => {
      state.isLoading = false;
      state.error = '';
      state.lastAction = action.type;
    },
    [deleteIncome.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = action.type;
    },
    [deleteIncome.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    },
    [setIncome.fulfilled.type]: (state, action: PayloadAction<Income>) => {
      state.isLoading = false;
      state.error = '';
      state.lastAction = action.type;
    },
    [setIncome.pending.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = true;
      state.lastAction = action.type;
    },
    [setIncome.rejected.type]: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
      state.lastAction = action.type;
    }
  }
});

export const { resetCurrentIncome, resetIncomes } = incomesSlice.actions;

export default incomesSlice.reducer;
